import React from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { cx } from "class-variance-authority";

export const Menu = ({
  isOpen,
  trigger,
  items,
  onRequestClose,
  className,
  align = "start",
  disabled,
}: {
  className?: string;
  isOpen: boolean;
  align?: "start" | "end";
  trigger: () => React.ReactNode;
  disabled?: boolean;
  items: {
    className?: string;
    label: (() => React.ReactNode) | string;
    action: () => void;
  }[];
  onRequestClose: (open: boolean) => void;
}) => (
  <DropdownMenu.Root open={isOpen} onOpenChange={onRequestClose}>
    <DropdownMenu.Trigger disabled={disabled}>{trigger()}</DropdownMenu.Trigger>
    <DropdownMenu.Content
      align={align}
      className={
        className ??
        "border-dublin-gray rounded border bg-white px-1 py-1 shadow-xl"
      }
    >
      {items.map((item, i) => {
        return (
          <DropdownMenu.Item
            onSelect={item.action}
            className={cx(
              !item.className ? "text-charcoal" : null,
              "focus:bg-friendly-eskimo rounded",
              "focus:outline-none",
              "w-full cursor-pointer py-1 pl-2 pr-10 text-base",
              item.className,
            )}
            key={i}
          >
            {typeof item.label === "string" ? item.label : item.label()}
          </DropdownMenu.Item>
        );
      })}
    </DropdownMenu.Content>
  </DropdownMenu.Root>
);

export default Menu;
